<template>
  <v-row>
    <v-col cols="12">
      <v-select
        :items="campaigns"
        v-model="selectedCampaign"
        item-text="name"
        item-value="id"
        label="Select Campaign"
        single-line
      />
    </v-col>
    <v-col cols="12">
      <v-select
        :disabled="!issues.length"
        v-model="selectedIssue"
        :items="issues"
        item-text="name"
        item-value="id"
        label="Select Issue"
        single-line
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'audience-report-item-selector',
    data () {
      return {
        selectedCampaign: null,
        selectedIssue: null
      }
    },
    props: {
      campaigns: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      issues () {
        if (!this.selectedCampaign) return []
        return this.campaigns.find(c => c.id === this.selectedCampaign).issues
      }
    }
  }
</script>
